export const MODEL_TYPES = {
  THEME_SETTINGS: 'https://paylix.gg/schema-definitions/theme-settings.json',
  SECTION_SETTINGS:
    'https://paylix.gg/schema-definitions/section-settings.json',
  LAYOUT_SETTINGS: 'https://paylix.gg/schema-definitions/layout-settings.json',
  BLOCK_SETTINGS: 'https://paylix.gg/schema-definitions/block-settings.json',
  TEMPLATE_SETTINGS:
    'https://paylix.gg/schema-definitions/template-settings.json',
};

export const applySchemeDefinitions = monaco => {
  // configure the JSON language support with schemas and schema associations
  monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
    validate: true,
    schemas: [
      {
        uri: MODEL_TYPES.THEME_SETTINGS,
        fileMatch: [MODEL_TYPES.THEME_SETTINGS], // associate with our model
        schema: {
          type: 'object',
          properties: {
            schema: {
              type: 'object',
              patternProperties: {
                '^.': {
                  type: 'array',
                  items: {
                    $ref: 'local://schema/item.json',
                  },
                },
              },
            },
            properties: {
              type: 'object',
              patternProperties: {
                '^.': {
                  $ref: 'local://properties.json',
                },
              },
            },
          },
        },
      },
      {
        uri: MODEL_TYPES.SECTION_SETTINGS,
        fileMatch: [MODEL_TYPES.SECTION_SETTINGS], // associate with our model
        schema: {
          type: 'object',
          properties: {
            class: { type: 'string' },
            blocks: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  name: { type: 'string' },
                  limit: { type: 'number' },
                },
                required: ['name'],
              },
            },
            schema: {
              $ref: 'local://common-schema.json',
            },
            properties: {
              $ref: 'local://properties.json',
            },
          },
        },
      },
      {
        uri: MODEL_TYPES.BLOCK_SETTINGS,
        fileMatch: [MODEL_TYPES.BLOCK_SETTINGS], // associate with our model
        schema: {
          type: 'object',
          properties: {
            class: { type: 'string' },
            schema: {
              $ref: 'local://common-schema.json',
            },
            properties: {
              $ref: 'local://properties.json',
            },
          },
        },
      },
      {
        uri: MODEL_TYPES.TEMPLATE_SETTINGS,
        fileMatch: [MODEL_TYPES.TEMPLATE_SETTINGS, MODEL_TYPES.LAYOUT_SETTINGS], // associate with our model
        schema: {
          type: 'object',
          properties: {
            class: { type: 'string' },
            sections: {
              type: 'object',
              patternProperties: {
                '^.': {
                  type: 'object',
                  properties: {
                    name: { type: 'string' },
                    settings: {
                      type: 'object',
                      properties: {
                        visible: { type: 'boolean' },
                        blocks: {
                          type: 'object',
                          patternProperties: {
                            '^.': {
                              type: 'object',
                              properties: {
                                name: { type: 'string' },
                                settings: {
                                  type: 'object',
                                  properties: {
                                    visible: { type: 'boolean' },
                                    properties: {
                                      $ref: 'local://properties.json',
                                    },
                                  },
                                },
                              },
                              required: ['name'],
                              additionalProperties: false,
                            },
                          },
                        },
                        block_order: {
                          type: 'array',
                          items: { type: ['string', 'number'] },
                        },
                        properties: {
                          $ref: 'local://properties.json',
                        },
                      },
                      dependentRequired: {
                        blocks: ['block_order'],
                        block_order: ['blocks'],
                      },
                    },
                  },
                  additionalProperties: false,
                  required: ['name'],
                },
              },
            },
            section_order: {
              type: 'array',
              items: { type: ['string', 'number'] },
            },
          },
          dependentRequired: {
            sections: ['section_order'],
            section_order: ['sections'],
          },
        },
      },
      {
        uri: 'local://common-schema.json',
        schema: {
          type: 'array',
          items: {
            $ref: 'local://schema/item.json',
          },
        },
      },
      {
        uri: 'local://schema/item.json',
        schema: {
          type: 'object',
          properties: {
            id: { type: 'string' },
            label: { type: 'string' },
            type: {
              enum: [
                'header',
                'text',
                'select',
                'select-image',
                'select-menu',
                'select-font',
                'select-link',
                'link-text',
                'checkbox',
                'range',
                'color-picker',
              ],
            },
            defaultValue: { type: ['string', 'number', 'null', 'boolean', 'object'] },
          },
          required: ['id', 'type'],
          additionalProperties: true,
        },
      },
      {
        uri: 'local://properties.json',
        schema: {
          type: 'object',
          patternProperties: {
            '^.': {
              type: ['string', 'number', 'null', 'boolean', 'object'],
            },
          },
        },
      },
    ],
  });
};
